import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Youtube, Mail, Phone, MapPin } from "lucide-react";
import LOGO_SRC from "@/assets/NischalamIcon.jpeg"

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-[#1E3F20] text-white/80 pt-24 pb-10 mt-24 overflow-hidden">
      <div className="absolute inset-0 opacity-[0.06] pointer-events-none"
        style={{ backgroundImage: "url('https://images.unsplash.com/photo-1500937386664-56d1dfef3854?auto=format&fit=crop&w=1600&q=60')",
                 backgroundSize: "cover", backgroundPosition: "center", filter: "grayscale(1)" }} />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <Link to="/" className="flex items-center gap-3 text-white">
            <span className="w-11 h-11 rounded-full overflow-hidden bg-white/10 border border-white/20 grid place-items-center">
              <img src={LOGO_SRC} alt="Nischalam logo" className="w-full h-full object-cover" />
            </span>
            <span className="font-display text-3xl tracking-tight">Nischalam</span>
          </Link>
          <div className="mt-6 flex items-center gap-3">
            <a href="https://www.instagram.com/nischalam_farms?igsh=cDh4amVuaWVta3lh"
               target="_blank" rel="noreferrer"
               data-testid="footer-instagram" aria-label="Instagram"
               className="w-10 h-10 rounded-full border border-white/25 grid place-items-center hover:bg-white/10 transition">
              <Instagram className="w-4 h-4" />
            </a>
            <a href="https://youtube.com/@nischalamproducts?si=W00n95_2_ZkcJFaE"
               target="_blank" rel="noreferrer"
               data-testid="footer-youtube" aria-label="YouTube"
               className="w-10 h-10 rounded-full border border-white/25 grid place-items-center hover:bg-white/10 transition">
              <Youtube className="w-4 h-4" />
            </a>
          </div>
        </div>

        <div className="md:col-span-3">
          <p className="uppercase text-xs tracking-[0.24em] text-white/50 mb-5">Explore</p>
          <ul className="space-y-3">
            <li><Link to="/products" className="hover:text-white link-underline">Products</Link></li>
            <li><Link to="/find-us" className="hover:text-white link-underline">Find Us</Link></li>
            <li><Link to="/about" className="hover:text-white link-underline">About Us</Link></li>
            <li><Link to="/foundation/english" className="hover:text-white link-underline">Foundation (English)</Link></li>
            <li><Link to="/foundation/telugu" className="hover:text-white link-underline">Foundation (తెలుగు)</Link></li>
            <li><Link to="/contact" className="hover:text-white link-underline">Contact</Link></li>
            <li><Link to="/admin" className="hover:text-white link-underline">Admin</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="uppercase text-xs tracking-[0.24em] text-white/50 mb-5">Reach us</p>
          <ul className="space-y-4 text-sm">
            <li className="flex gap-3"><MapPin className="w-4 h-4 mt-1 text-[color:var(--brand-sage)] flex-shrink-0" />
              <span>5-88, Balijapalle, Ramachandrapuram Mandalam,<br />Andhra Pradesh 517561, India</span></li>
            <li className="flex gap-3"><Phone className="w-4 h-4 mt-1 text-[color:var(--brand-sage)] flex-shrink-0" />
              <a href="tel:+919676245533" className="hover:text-white">+91 9676245533</a></li>
            <li className="flex gap-3"><Mail className="w-4 h-4 mt-1 text-[color:var(--brand-sage)] flex-shrink-0" />
              <a href="mailto:nischalamproducts@gmail.com" className="hover:text-white break-all">nischalamproducts@gmail.com</a></li>
          </ul>
        </div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 md:px-12 mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-white/50">
        <p>Copyright © 2020 Nischalam. All Rights Reserved.</p>
        <div className="flex items-center gap-6">
          <Link to="/privacy" className="hover:text-white">Privacy Policy</Link>
          <Link to="/terms" className="hover:text-white">Terms &amp; Conditions</Link>
        </div>
      </div>
    </footer>
  );
}
